<template>
    <ResourceInput
        label="Publication date"
        attribute="publishAt"
        type="date"
    />
</template>
